import { FC, useEffect, useMemo, useState } from 'react';
import styles from './DaysUntilRecommendedFill.module.scss';
import { differenceInDays } from 'date-fns';
import classNames from 'classnames';

interface DaysUntilRecommendedFillProps {
    duf_7: number;
}

const DaysUntilRecommendedFill: FC<DaysUntilRecommendedFillProps> = ({
    duf_7,
}) => {
    const [days, setDays] = useState<number | null>(null);
    useEffect(() => {
        if (!duf_7) return;
        const recFillDate = new Date(duf_7);
        const now = new Date();
        const distance = differenceInDays(recFillDate, now);
        setDays(distance);
    }, [duf_7]);

    const getClassNames = useMemo(() => {
        const names = [styles.DaysUntilRecommendedFill];
        if (days === null) return classNames(names);
        if (days >= 7) return classNames(names, styles.ok);
        else if (days >= 0) return classNames(names, styles.warning);
        return classNames(names, styles.overdue);
    }, [days]);

    return (
        <div className={getClassNames} data-testid="DaysUntilRecommendedFill">
            {days !== null ? days : 'N/A'}
        </div>
    );
};

export default DaysUntilRecommendedFill;
